import React from "react";
import PropTypes from "prop-types";
import ChartistGraph from "react-chartist";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import FormControl from "@material-ui/core/FormControl/FormControl";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

// @material-ui/icons
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import PersonIcon from "@material-ui/icons/Person";
import AttachMoney from "@material-ui/icons/AttachMoney";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import {
  emailsSubscriptionChart
} from "variables/charts";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import { convertToCurrency, calculatePercent, getMonthNameFromDate } from "../../assets/helpers/dataHelper";

import {API_ROOT} from 'api-config';
import { getApiHeaders } from "../../assets/helpers/apiHelper";

import axios from "axios";

// import { CircularProgress } from '@material-ui/core';
import { validateDateFormatAndOrder } from "../../assets/helpers/formHelper";

import SweetAlert from "react-bootstrap-sweetalert";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import { getUserGroups } from "../../assets/helpers/utilityHelper";

const styles = {
  ...sweetAlertStyle,
  ...dashboardStyle
};

var moment = require('moment');

var userGroups = getUserGroups()

class Dashboard extends React.Component {

  constructor(props) {
    super(props)
    var showCirrusAdminInfo = false
    var selectedDentist = ''
    if (userGroups.indexOf('cirrusAdmin') >= 0) {
      showCirrusAdminInfo = true
    } else {
      selectedDentist = sessionStorage.getItem('userId')
    }

    this.state = {
      value: 0,
      activeMembers: 158,
      subscriptionRevenue: 4740,
      totalRevenue: 8317,
      memberChangePercent: 24,
      revenueChangePercent: 39,
      monthlyPatientMembers: {},
      monthlyDentistMembers: {},
      monthlyCirrusRevenue: {},
      monthlyDentistRevenue: {},
      alert: '',
      loadingAccounting: false,
      loadingMembers: false,
      patientId: '',
      employerId: '',
      startDate: '',
      endDate: '',
      startDateSend: '',
      endDateSend: '',
      paymentsFromPatients: '',
      netPaymentsFromPatients: '',
      paymentsToDentistFullAmount: '',
      paymentsToDentistDiscountAmount: '',
      paymentsToDentistPayoutAmount: '',
      nestEggBalance: '',
      revenue: '',
      memberPatients: '',
      memberDentists: '',
      memberEmployers: '',
      dentistList: [{id: 0, name: 'loading...'}],
      selectedDentist: selectedDentist,
      changeInCirrusRevenuePercent: 0,
      changeInDentistRevenuePercent: 0,
      changeInNewPatientsPercent: 0,
      changeInNewDentistsPercent: 0,
      showCirrusAdminInfo: showCirrusAdminInfo
    }
  }


  componentDidMount() {
    this._isMounted = true;
    this.getAccounting()
    this.getMembers()
    if (this.state.showCirrusAdminInfo) {
      this.getDentistList()
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  filterAccountingData() {
    var validDateInfo = validateDateFormatAndOrder(this.state.startDate, this.state.endDate)
    var validStartDate = validDateInfo.validStartDate
    var validEndDate = validDateInfo.validEndDate
    var alertMessage = validDateInfo.alertMessage

    if (alertMessage) {
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="check the dates"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            {alertMessage}
          </SweetAlert>
        )
      });
    } else {
      if (!validStartDate) {
        this.setState({
          startDate: ''
        })
        validStartDate = ''
      }
      if (!validEndDate) {
        this.setState({
          endDate: ''
        })
        validEndDate = ''
      }
      this.getAccounting(validStartDate, validEndDate)
      this.getMembers(validStartDate, validEndDate)
    }
  }

  getAccounting(startDate = '', endDate = '') {
    this.setState({
      loadingAccounting: true
    })
    axios.get(`${API_ROOT}/accounting/?dentistId=` + this.state.selectedDentist +
      `&patientId=` + this.state.patientId + `&startDate=` + startDate +
      `&endDate=` + endDate + `&timeSeriesFrequency=monthly`, {headers: getApiHeaders()})
      .then(res => this.setAccounting({responseMessage: res.data}));
  }

  setAccounting(res) {
    if (this._isMounted) {
      const accountingData = res.responseMessage['summaryData']
      const monthlyData = res.responseMessage['monthlyData']
      var row
      var months = []
      var dentistRevenue = []
      var cirrusRevenue = []
      for (row in monthlyData) {
        const currentMonth = monthlyData[row]
        months.push(getMonthNameFromDate(currentMonth['month']))
        const accountingData = currentMonth['accountingData']
        dentistRevenue.push(accountingData['paymentsToDentistPayoutAmount'])
        cirrusRevenue.push(accountingData['revenue'])
      }

      months = months.reverse()
      cirrusRevenue = cirrusRevenue.reverse()
      dentistRevenue = dentistRevenue.reverse()
      const thisMonthCirrusRevenue = parseInt(cirrusRevenue[cirrusRevenue.length - 1])
      const lastMonthCirrusRevenue = parseInt(cirrusRevenue[cirrusRevenue.length - 2])
      const thisMonthDentistRevenue = dentistRevenue[dentistRevenue.length - 1]
      const lastMonthDentistRevenue = dentistRevenue[dentistRevenue.length - 2]

      const changeInCirrusRevenuePercent = calculatePercent(thisMonthCirrusRevenue, lastMonthCirrusRevenue)
      const changeInDentistRevenuePercent = calculatePercent(thisMonthDentistRevenue, lastMonthDentistRevenue)

      const monthlyCirrusRevenue =  {
        labels: months,
          series: [cirrusRevenue],
      }
      const monthlyDentistRevenue =  {
        labels: months,
        series: [dentistRevenue],
      }
      this.setState({
        loadingAccounting: false,
        paymentsFromPatients: accountingData.paymentsFromPatients,
        netPaymentsFromPatients: accountingData.netPaymentsFromPatients,
        paymentsToDentistFullAmount: accountingData.paymentsToDentistFullAmount,
        paymentsToDentistDiscountAmount: accountingData.paymentsToDentistDiscountAmount,
        paymentsToDentistPayoutAmount: accountingData.paymentsToDentistPayoutAmount,
        nestEggBalance: accountingData.nestEggBalance,
        revenue: accountingData.revenue,
        monthlyCirrusRevenue: monthlyCirrusRevenue,
        monthlyDentistRevenue: monthlyDentistRevenue,
        changeInCirrusRevenuePercent: changeInCirrusRevenuePercent,
        changeInDentistRevenuePercent: changeInDentistRevenuePercent
      })
    }
  }


  getMembers(startDate = '', endDate = '') {
    this.setState({
      loadingMembers: true
    })
    axios.get(`${API_ROOT}/members/?dentistId=` + this.state.selectedDentist +
      `&employerId=` + this.state.employerId + `&startDate=` + startDate +
      `&endDate=` + endDate + `&timeSeriesFrequency=monthly`, {headers: getApiHeaders()})
      .then(res => this.setMembers({responseMessage: res.data}));
  }

  setMembers(res) {
    if (this._isMounted) {
      const memberData = res.responseMessage['summaryData']
      const monthlyData = res.responseMessage['monthlyData']

      var row
      var months = []
      var newDentists = []
      var newPatients = []
      for (row in monthlyData) {
        const currentMonth = monthlyData[row]
        months.push(getMonthNameFromDate(currentMonth['month']))
        const memberData = currentMonth['memberData']
        newDentists.push(memberData['memberDentists'])
        newPatients.push(memberData['memberPatients'])
      }

      months = months.reverse()
      newDentists = newDentists.reverse()
      newPatients = newPatients.reverse()
      const thisMonthNewDentists = newDentists[newDentists.length - 1]
      const lastMonthNewDentists = newDentists[newDentists.length - 2]
      const thisMonthNewPatients = parseInt(newPatients[newPatients.length - 1])
      const lastMonthNewPatients = parseInt(newPatients[newPatients.length - 2])

      const changeInNewDentistsPercent = calculatePercent(thisMonthNewDentists, lastMonthNewDentists)
      const changeInNewPatientsPercent = calculatePercent(thisMonthNewPatients, lastMonthNewPatients)

      const monthlyDentistMembers =  {
        labels: months,
        series: [newDentists],
      }
      const monthlyPatientMembers =  {
        labels: months,
        series: [newPatients],
      }

      this.setState({
        loadingMembers: false,
        memberPatients: memberData.memberPatients,
        memberDentists: memberData.memberDentists,
        memberEmployers: memberData.memberEmployers,
        monthlyDentistMembers: monthlyDentistMembers,
        changeInNewDentistsPercent: changeInNewDentistsPercent,
        monthlyPatientMembers: monthlyPatientMembers,
        changeInNewPatientsPercent: changeInNewPatientsPercent
      })
    }
  }

  getDentistList() {

    axios.get(`${API_ROOT}/provider/?allProviders=true`, {headers: getApiHeaders()})
      .then(res => this.setDentistList({responseMessage: res.data}));
  }

  setDentistList(res) {
    if (this._isMounted) {
      this.setState({
        dentistList: res.responseMessage
      })
    }
  }



  handleDateChange(event, dateType) {
    var dateValue = '';
    if (event instanceof moment) {
      dateValue = event.format("MM/DD/YYYY")
    } else {
      dateValue = event
    }
    this.setState({
      [dateType]: dateValue
    })
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  handleChange = (event, stateName) => {
    this.setState({ [stateName]: event.target.value });
  };
  handleChangeIndex = index => {
    this.setState({ value: index });
  };
  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.state.alert}
        <GridContainer>
          <GridItem xs={3}>
            <InputLabel className={classes.label}>from date</InputLabel>
            <br />
            <FormControl fullWidth>
              <Datetime
                onChange={(event) => {this.handleDateChange(event, 'startDate');}}
                timeFormat={false}
                inputProps={{
                  placeholder: "from date",
                  id: "startDate",
                  value: this.state.startDate
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={3}>
            <InputLabel className={classes.label}>to date</InputLabel>
            <br />
            <FormControl fullWidth>
              <Datetime
                onChange={(event) => {this.handleDateChange(event, 'endDate');}}
                timeFormat={false}
                inputProps={{
                  placeholder: "to date",
                  id: "endDate",
                  value: this.state.endDate
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={3} style={this.state.showCirrusAdminInfo ? {} : { display: 'none' }}>
            <FormControl
              fullWidth
              className={classes.selectFormControl}
            >
              <InputLabel
                htmlFor="simple-select"
                className={classes.selectLabel}
              >
                office
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu
                }}
                classes={{
                  select: classes.select
                }}
                value={this.state.selectedDentist}

                inputProps={{
                  id: "selectedDentist",
                  name: "selectedDentist",
                  onChange: event => this.handleChange(event, "selectedDentist")
                }}

              >
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value=''
                >
                  all
                </MenuItem>
                {this.state.dentistList.map((dentist) =>
                  <MenuItem classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }} key={dentist['id']} value={dentist['id']} >{dentist['name']}</MenuItem>
                )}

              </Select>
            </FormControl>


          </GridItem>
          <GridItem xs={3}>
            <Button color="cirrusBlue"  onClick={this.filterAccountingData.bind(this)} className={classes.updateProfileButton} type="submit">
              filter
            </Button>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6} lg={4}>
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="cirrusBlue">
                  <PersonIcon />
                </CardIcon>
                <p className={classes.cardCategory}>Patients</p>
                <h3 className={classes.cardTitle}>
                  {this.state.memberPatients}
                </h3>
              </CardHeader>
              <CardFooter stats>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={4} style={this.state.showCirrusAdminInfo ? {} : { display: 'none' }}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="cirrusBlue">
                  <PersonIcon />
                </CardIcon>
                <p className={classes.cardCategory}>Dentists</p>
                <h3 className={classes.cardTitle}>{this.state.memberDentists}</h3>
              </CardHeader>
              <CardFooter stats>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={4} style={this.state.showCirrusAdminInfo ? {} : { display: 'none' }}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="cirrusBlue">
                  <PersonIcon />
                </CardIcon>
                <p className={classes.cardCategory}>Employers</p>
                <h3 className={classes.cardTitle}>{this.state.memberEmployers}</h3>
              </CardHeader>
              <CardFooter stats>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6} lg={3} style={this.state.showCirrusAdminInfo ? {} : { display: 'none' }}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <AttachMoney />
                </CardIcon>
                <p className={classes.cardCategory}>Patients revenue</p>
                <h3 className={classes.cardTitle}>{convertToCurrency(this.state.netPaymentsFromPatients)}</h3>
              </CardHeader>
              <CardFooter stats>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <AttachMoney />
                </CardIcon>
                <p className={classes.cardCategory}>Revenue<span style={this.state.showCirrusAdminInfo ? {} : { display: 'none' }}> to dentists</span></p>
                <h3 className={classes.cardTitle}>{convertToCurrency(this.state.paymentsToDentistPayoutAmount)}</h3>
              </CardHeader>
              <CardFooter stats>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} lg={3} style={this.state.showCirrusAdminInfo ? {} : { display: 'none' }}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <AttachMoney />
                </CardIcon>
                <p className={classes.cardCategory}>Cirrus revenue</p>
                <h3 className={classes.cardTitle}>{convertToCurrency(this.state.revenue)}</h3>
              </CardHeader>
              <CardFooter stats>
              </CardFooter>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={6} md={6} lg={3}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <AttachMoney />
                </CardIcon>
                <p className={classes.cardCategory}>Nest egg balance</p>
                <h3 className={classes.cardTitle}>{convertToCurrency(this.state.nestEggBalance)}</h3>
              </CardHeader>
              <CardFooter stats>
              </CardFooter>
            </Card>
          </GridItem>

        </GridContainer>
        <GridContainer>


        </GridContainer>

        <GridContainer style={this.state.showCirrusAdminInfo ? {} : { display: 'none' }}>
          <GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <CardHeader color="success">
                <ChartistGraph
                  className="ct-chart-white-colors"
                  data={this.state.monthlyCirrusRevenue}
                  type="Line"
                  responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                  listener={emailsSubscriptionChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Monthly revenue - Cirrus</h4>
                <p className={classes.cardCategory}>
                  <span className={this.state.changeInCirrusRevenuePercent <= 0 ? classes.failText : classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} style={this.state.changeInCirrusRevenuePercent < 0 ? { display: 'none' } : {}} />
                    <ArrowDownward className={classes.downArrowCardCategory} style={this.state.changeInCirrusRevenuePercent >= 0 ? { display: 'none' } : {}} />
                    {this.state.changeInCirrusRevenuePercent}%
                  </span>{" "}
                  change in revenue this month.
                </p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <CardHeader color="cirrusBlue">
                <ChartistGraph
                  className="ct-chart-white-colors"
                  data={this.state.monthlyDentistMembers}
                  type="Line"
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>new dentists</h4>
                <p className={classes.cardCategory}>
                  <span className={this.state.changeInNewDentistsPercent <= 0 ? classes.failText : classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} style={this.state.changeInNewDentistsPercent < 0 ? { display: 'none' } : {}} />
                    <ArrowDownward className={classes.downArrowCardCategory} style={this.state.changeInNewDentistsPercent >= 0 ? { display: 'none' } : {}} />
                    {this.state.changeInNewDentistsPercent}%
                  </span>{" "}
                  change in dentist members this month.
                </p>
              </CardBody>

            </Card>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <CardHeader color="success">
                <ChartistGraph
                  className="ct-chart-white-colors"
                  data={this.state.monthlyDentistRevenue}
                  type="Line"
                  responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                  listener={emailsSubscriptionChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Monthly revenue<span style={this.state.showCirrusAdminInfo ? {} : { display: 'none' }}> - dentist</span></h4>
                <p className={classes.cardCategory}>
                  <span className={this.state.changeInDentistRevenuePercent <= 0 ? classes.failText : classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} style={this.state.changeInDentistRevenuePercent < 0 ? { display: 'none' } : {}} />
                    <ArrowDownward className={classes.downArrowCardCategory} style={this.state.changeInDentistRevenuePercent >= 0 ? { display: 'none' } : {}} />
                    {this.state.changeInDentistRevenuePercent}%
                  </span>{" "}
                  change in revenue this month.
                </p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <CardHeader color="cirrusBlue">
                <ChartistGraph
                  className="ct-chart-white-colors"
                  data={this.state.monthlyPatientMembers}
                  type="Line"
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>new patients</h4>
                <p className={classes.cardCategory}>
                  <span className={this.state.changeInNewPatientsPercent <= 0 ? classes.failText : classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} style={this.state.changeInNewPatientsPercent < 0 ? { display: 'none' } : {}} />
                    <ArrowDownward className={classes.downArrowCardCategory} style={this.state.changeInNewPatientsPercent >= 0 ? { display: 'none' } : {}} />
                    {this.state.changeInNewPatientsPercent}%
                  </span>{" "}
                  change in patient members this month.
                </p>
              </CardBody>

            </Card>
          </GridItem>
        </GridContainer>

      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Dashboard);
